import {
  FileChatMessage,
  ImageOrVideoChatMessage,
  MessageType,
  VideoCallChatMessage,
} from '../../../types/chat.types';
import { Message } from './chatSocketReducer.types';

export const isImageOrVideoMessageType = (
  props: Message,
): props is ImageOrVideoChatMessage & { chatId: string } => {
  return props.type === MessageType.IMAGE_OR_VIDEO;
};

export const isFileMessageType = (
  props: Message,
): props is FileChatMessage & { chatId: string } => {
  return props.type === MessageType.FILE;
};

export const isVideoCallMessageType = (
  props: Message,
): props is VideoCallChatMessage & { chatId: string } => {
  return props.type === MessageType.VIDEO_CALL;
};
